import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderAddRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folder-add-right"} maskId="square-filled-radius-0-stroke-1-IconFolderAddRight"><path d="M10.2676 3H2V20H14.2572C13.4718 19.0491 13 17.8296 13 16.5C13 13.4624 15.4624 11 18.5 11C19.8296 11 21.0491 11.4718 22 12.2572V6H12.2676L10.2676 3Z" fill="currentColor"/><path d="M19 13H18V16H15V17H18V20H19V17H22V16H19V13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolderAddRight;
